import React from 'react';
import './Modal.css';

function Modal({ isOpen, onClose, title, children, size = 'normal', actions, headerExtras }) {
  if (!isOpen) return null;

  const isFullscreen = size === 'fullscreen';

  return (
    <div
      className={`modal-overlay ${isFullscreen ? 'modal-overlay--fullscreen' : ''}`}
      onClick={onClose}
    >
      <div 
        className={`modal ${size === 'small' ? 'modal-small' : ''} ${size === 'large' ? 'modal-large' : ''} ${isFullscreen ? 'modal-fullscreen' : ''}`}
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>{title}</h3>
          {/* Build 26: optional inline header buttons (Copy Link, Pin, Fullscreen, etc.) */}
          {headerExtras && <div className="modal-header-extras">{headerExtras}</div>}
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="modal-body">
          {children}
        </div>

        {actions && (
          <div className="modal-actions">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}

export default Modal;
